// extracted by mini-css-extract-plugin
export default {"commonList":"CommonList_commonList__4hIY-"};